export const Star = ({ color = "#FACC15" }) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="star 5" clipPath="url(#clip0_1021_3178)">
        <g id="Layer 2">
          <g id="star">
            <path
              id="Vector"
              d="M8.64523 10.3383C8.56649 10.3386 8.48883 10.32 8.41876 10.2841L5.90786 8.96959L3.39696 10.2841C3.31543 10.327 3.2235 10.3461 3.13164 10.3394C3.03977 10.3326 2.95164 10.3002 2.87727 10.2458C2.80291 10.1914 2.74528 10.1173 2.71096 10.0318C2.67663 9.94634 2.66697 9.85295 2.68308 9.76225L3.17542 6.99041L1.147 5.02108C1.08372 4.95793 1.03883 4.87874 1.01714 4.792C0.995457 4.70526 0.997801 4.61426 1.02392 4.52875C1.05246 4.44125 1.10495 4.3635 1.17544 4.30433C1.24593 4.24515 1.33159 4.20692 1.42271 4.19397L4.22901 3.78533L5.46476 1.25966C5.50508 1.17642 5.56802 1.10622 5.64639 1.0571C5.72476 1.00799 5.81537 0.981934 5.90786 0.981934C6.00035 0.981934 6.09097 1.00799 6.16933 1.0571C6.2477 1.10622 6.31065 1.17642 6.35096 1.25966L7.60148 3.78041L10.4078 4.18904C10.4989 4.20199 10.5846 4.24023 10.6551 4.2994C10.7255 4.35858 10.778 4.43633 10.8066 4.52383C10.8327 4.60933 10.835 4.70034 10.8134 4.78708C10.7917 4.87381 10.7468 4.95301 10.6835 5.01616L8.65508 6.98549L9.14741 9.75732C9.16499 9.84962 9.15578 9.94503 9.12089 10.0323C9.08599 10.1195 9.02686 10.1949 8.95048 10.2497C8.86132 10.3121 8.75398 10.3433 8.64523 10.3383Z"
              fill={color}
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1021_3178">
          <rect
            width="11.816"
            height="11.816"
            fill="white"
            transform="translate(0 -0.000488281)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const UploadImg = ({ color = "#A273FF" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="57"
      height="56"
      viewBox="0 0 57 56"
      fill="none"
    >
      <g clip-path="url(#clip0_3677_14375)">
        <path
          d="M23.8346 37.3332H33.168C34.4513 37.3332 35.5013 36.2832 35.5013 34.9998V23.3332H39.2113C41.288 23.3332 42.338 20.8132 40.868 19.3432L30.158 8.63318C29.248 7.72318 27.778 7.72318 26.868 8.63318L16.158 19.3432C14.688 20.8132 15.7146 23.3332 17.7913 23.3332H21.5013V34.9998C21.5013 36.2832 22.5513 37.3332 23.8346 37.3332ZM14.5013 41.9998H42.5013C43.7846 41.9998 44.8346 43.0498 44.8346 44.3332C44.8346 45.6165 43.7846 46.6665 42.5013 46.6665H14.5013C13.218 46.6665 12.168 45.6165 12.168 44.3332C12.168 43.0498 13.218 41.9998 14.5013 41.9998Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_3677_14375">
          <rect
            width="56"
            height="56"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const SmartStar = ({
  className = "",
  transitionDelay = "0s",
  transitionDuration = "0s",
  color = "#FACC15",
  clipPath = "inset(0 0 0 0)",
}) => {
  return (
    <svg
      className={className}
      style={{
        transitionDelay: { transitionDelay },
        transitionDuration: { transitionDuration },
      }}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill={color}
      clipPath={clipPath}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="star 5" clipPath="url(#clip0_1021_3178)">
        <g id="Layer 2">
          <g id="star">
            <path
              id="Vector"
              d="M8.64523 10.3383C8.56649 10.3386 8.48883 10.32 8.41876 10.2841L5.90786 8.96959L3.39696 10.2841C3.31543 10.327 3.2235 10.3461 3.13164 10.3394C3.03977 10.3326 2.95164 10.3002 2.87727 10.2458C2.80291 10.1914 2.74528 10.1173 2.71096 10.0318C2.67663 9.94634 2.66697 9.85295 2.68308 9.76225L3.17542 6.99041L1.147 5.02108C1.08372 4.95793 1.03883 4.87874 1.01714 4.792C0.995457 4.70526 0.997801 4.61426 1.02392 4.52875C1.05246 4.44125 1.10495 4.3635 1.17544 4.30433C1.24593 4.24515 1.33159 4.20692 1.42271 4.19397L4.22901 3.78533L5.46476 1.25966C5.50508 1.17642 5.56802 1.10622 5.64639 1.0571C5.72476 1.00799 5.81537 0.981934 5.90786 0.981934C6.00035 0.981934 6.09097 1.00799 6.16933 1.0571C6.2477 1.10622 6.31065 1.17642 6.35096 1.25966L7.60148 3.78041L10.4078 4.18904C10.4989 4.20199 10.5846 4.24023 10.6551 4.2994C10.7255 4.35858 10.778 4.43633 10.8066 4.52383C10.8327 4.60933 10.835 4.70034 10.8134 4.78708C10.7917 4.87381 10.7468 4.95301 10.6835 5.01616L8.65508 6.98549L9.14741 9.75732C9.16499 9.84962 9.15578 9.94503 9.12089 10.0323C9.08599 10.1195 9.02686 10.1949 8.95048 10.2497C8.86132 10.3121 8.75398 10.3433 8.64523 10.3383Z"
              fill="#D1D5DB"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};
export const SearchLg = ({ fill = "none", color = "white" }) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="search-lg">
        <path
          id="Icon"
          d="M14.6797 14L12.3464 11.6667M14.013 7.66667C14.013 10.7963 11.476 13.3333 8.34635 13.3333C5.21674 13.3333 2.67969 10.7963 2.67969 7.66667C2.67969 4.53705 5.21674 2 8.34635 2C11.476 2 14.013 4.53705 14.013 7.66667Z"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          // L="round"
        />
      </g>
    </svg>
  );
};
export const ClocheState = ({ fill = "none", color = "#1E1A21" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill={fill}
    >
      <path
        d="M19.9996 25.3332C19.9996 27.5423 18.2088 29.3332 15.9996 29.3332C13.7905 29.3332 11.9996 27.5423 11.9996 25.3332M18.395 8.31791C18.9756 7.71803 19.333 6.90066 19.333 5.99984C19.333 4.15889 17.8406 2.6665 15.9996 2.6665C14.1587 2.6665 12.6663 4.15889 12.6663 5.99984C12.6663 6.90066 13.0236 7.71803 13.6043 8.31791M23.9996 14.9332C23.9996 13.0943 23.1568 11.3308 21.6565 10.0306C20.1562 8.73031 18.1214 7.99984 15.9996 7.99984C13.8779 7.99984 11.8431 8.73031 10.3428 10.0306C8.84248 11.3308 7.99963 13.0943 7.99963 14.9332C7.99963 17.9756 7.24514 20.2006 6.30371 21.7927C5.23075 23.6073 4.69426 24.5146 4.71545 24.7314C4.73969 24.9793 4.78432 25.0576 4.98541 25.2046C5.16119 25.3332 6.04431 25.3332 7.81055 25.3332H24.1887C25.9549 25.3332 26.8381 25.3332 27.0138 25.2046C27.2149 25.0576 27.2596 24.9793 27.2838 24.7314C27.305 24.5146 26.7685 23.6073 25.6955 21.7927C24.7541 20.2006 23.9996 17.9756 23.9996 14.9332Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const SearchLgN = ({ color = "white" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M14 14L11.6667 11.6667M13.3333 7.66667C13.3333 10.7963 10.7963 13.3333 7.66667 13.3333C4.53705 13.3333 2 10.7963 2 7.66667C2 4.53705 4.53705 2 7.66667 2C10.7963 2 13.3333 4.53705 13.3333 7.66667Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const FlagIcon = ({ color = "#EF4444" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
    >
      <path
        d="M2.66663 9.60954H13.058C13.3663 9.60954 13.5205 9.60954 13.6085 9.54488C13.6853 9.48851 13.7343 9.40198 13.7431 9.30714C13.7533 9.19838 13.6739 9.06618 13.5153 8.80181L12.1646 6.5506C12.1047 6.45084 12.0748 6.40095 12.0631 6.3477C12.0528 6.3006 12.0528 6.25181 12.0631 6.20471C12.0748 6.15146 12.1047 6.10157 12.1646 6.00181L13.5153 3.7506C13.6739 3.48622 13.7533 3.35403 13.7431 3.24527C13.7343 3.15043 13.6853 3.0639 13.6085 3.00752C13.5205 2.94287 13.3663 2.94287 13.058 2.94287H2.66663L2.66663 14.9429"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const Setting04 = ({ color = "white", stroke = "#1E1A21" }) => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="settings-04">
        <path
          id="Icon"
          d="M2.75 6L11.75 6M11.75 6C11.75 7.24264 12.7574 8.25 14 8.25C15.2426 8.25 16.25 7.24264 16.25 6C16.25 4.75736 15.2426 3.75 14 3.75C12.7574 3.75 11.75 4.75736 11.75 6ZM7.25 12L16.25 12M7.25 12C7.25 13.2426 6.24264 14.25 5 14.25C3.75736 14.25 2.75 13.2426 2.75 12C2.75 10.7574 3.75736 9.75 5 9.75C6.24264 9.75 7.25 10.7574 7.25 12Z"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
export const Marker = ({
  color = "none",
  stroke = "#A273FF",
  strokeWidth = 2,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill={color}
    >
      <path
        d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 22C16 18 20 14.4183 20 10C20 5.58172 16.4183 2 12 2C7.58172 2 4 5.58172 4 10C4 14.4183 8 18 12 22Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const BankNote = ({ color = "white" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 11V15M18 9V13M17 4C19.4487 4 20.7731 4.37476 21.4321 4.66544C21.5199 4.70415 21.5638 4.72351 21.6904 4.84437C21.7663 4.91682 21.9049 5.12939 21.9405 5.22809C22 5.39274 22 5.48274 22 5.66274V16.4111C22 17.3199 22 17.7743 21.8637 18.0079C21.7251 18.2454 21.5914 18.3559 21.3319 18.4472C21.0769 18.5369 20.562 18.438 19.5322 18.2401C18.8114 18.1017 17.9565 18 17 18C14 18 11 20 7 20C4.55129 20 3.22687 19.6252 2.56788 19.3346C2.48012 19.2958 2.43624 19.2765 2.3096 19.1556C2.23369 19.0832 2.09512 18.8706 2.05947 18.7719C2 18.6073 2 18.5173 2 18.3373L2 7.58885C2 6.68009 2 6.2257 2.13628 5.99214C2.2749 5.75456 2.40859 5.64412 2.66806 5.55281C2.92314 5.46305 3.43803 5.56198 4.46783 5.75985C5.18862 5.89834 6.04348 6 7 6C10 6 13 4 17 4ZM14.5 12C14.5 13.3807 13.3807 14.5 12 14.5C10.6193 14.5 9.5 13.3807 9.5 12C9.5 10.6193 10.6193 9.5 12 9.5C13.3807 9.5 14.5 10.6193 14.5 12Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const Home = ({ color = "white", strokeWidth = 2 }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 21V13.6C9 13.0399 9 12.7599 9.109 12.546C9.20487 12.3578 9.35785 12.2049 9.54601 12.109C9.75993 12 10.04 12 10.6 12H13.4C13.9601 12 14.2401 12 14.454 12.109C14.6422 12.2049 14.7951 12.3578 14.891 12.546C15 12.7599 15 13.0399 15 13.6V21M2 9.5L11.04 2.72C11.3843 2.46181 11.5564 2.33271 11.7454 2.28294C11.9123 2.23902 12.0877 2.23902 12.2546 2.28295C12.4436 2.33271 12.6157 2.46181 12.96 2.72L22 9.5M4 8V17.8C4 18.9201 4 19.4802 4.21799 19.908C4.40974 20.2843 4.7157 20.5903 5.09202 20.782C5.51985 21 6.0799 21 7.2 21H16.8C17.9201 21 18.4802 21 18.908 20.782C19.2843 20.5903 19.5903 20.2843 19.782 19.908C20 19.4802 20 18.9201 20 17.8V8L13.92 3.44C13.2315 2.92361 12.8872 2.66542 12.5091 2.56589C12.1754 2.47804 11.8246 2.47804 11.4909 2.56589C11.1128 2.66542 10.7685 2.92361 10.08 3.44L4 8Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const Trash = ({ color = "black", strokeWidth = 2 }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="trash-04">
        <path
          id="Icon"
          d="M9 3H15M3 6H21M19 6L18.2987 16.5193C18.1935 18.0975 18.1409 18.8867 17.8 19.485C17.4999 20.0118 17.0472 20.4353 16.5017 20.6997C15.882 21 15.0911 21 13.5093 21H10.4907C8.90891 21 8.11803 21 7.49834 20.6997C6.95276 20.4353 6.50009 20.0118 6.19998 19.485C5.85911 18.8867 5.8065 18.0975 5.70129 16.5193L5 6"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
export const Room = ({ color = "1E1A21", strokeWidth = 2 }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="room">
        <path
          id="Vector"
          d="M2.66699 29.3332H29.3337M22.1542 3.61707V28.6493M5.74085 28.3816V3.57708C5.74085 3.07417 6.17982 2.6665 6.72239 2.6665M6.72239 2.6665H21.1808C21.7224 2.6665 22.1614 3.07417 22.1614 3.57708V28.3816M6.72239 2.6665H25.2311C25.7726 2.6665 26.2126 3.07417 26.2126 3.57708V28.3816"
          stroke={color}
          strokeWidth={strokeWidth}
          stroke-miterlimit="10"
        />
        <g id="Vector_2">
          <path
            d="M19.385 16.1266C19.385 16.6573 18.9542 17.0881 18.4235 17.0881C17.8927 17.0881 17.4619 16.6573 17.4619 16.1266C17.4619 15.5958 17.8927 15.165 18.4235 15.165C18.9542 15.165 19.385 15.5958 19.385 16.1266Z"
            fill="#1E1A21"
          />
          <path
            d="M19.385 16.1266C19.385 16.6573 18.9542 17.0881 18.4235 17.0881C17.8927 17.0881 17.4619 16.6573 17.4619 16.1266C17.4619 15.5958 17.8927 15.165 18.4235 15.165C18.9542 15.165 19.385 15.5958 19.385 16.1266Z"
            fill="#1E1A21"
          />
        </g>
      </g>
    </svg>
  );
};
export const XClose = ({ color = "#6B7280", strokeWidth = 2 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M18 6L6 18M6 6L18 18"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const Check = ({ color = "#6B7280", strokeWidth = 2 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M20 6L9 17L4 12"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Heart = ({ color = "transparent", stroke = "#1E1A21" }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="heart">
        <path
          id="Icon"
          d="M10.7404 2C13.0886 2 14.6663 4.235 14.6663 6.32C14.6663 10.5425 8.11819 14 7.99967 14C7.88116 14 1.33301 10.5425 1.33301 6.32C1.33301 4.235 2.91079 2 5.25893 2C6.60708 2 7.48856 2.6825 7.99967 3.2825C8.51079 2.6825 9.39227 2 10.7404 2Z"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
export const Wallet = ({ color = "none", stroke = "#F57148" }) => {
  return (
    <svg
      alt="alt-wallet"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="wallet-05">
        <path
          id="Icon"
          d="M15.8337 8.33325L4.16702 8.33325M15.8337 8.33325L17.3872 10.9224C17.7353 11.5026 17.9094 11.7927 17.9998 12.105C18.0799 12.3818 18.1116 12.6703 18.0934 12.9578C18.0729 13.2823 17.9659 13.6033 17.7519 14.2453L17.5787 14.7648C17.2509 15.7484 17.087 16.2401 16.7829 16.6037C16.5144 16.9248 16.1696 17.1733 15.7801 17.3265C15.3391 17.4999 14.8207 17.4999 13.784 17.4999L6.21673 17.4999C5.18 17.4999 4.66164 17.4999 4.22057 17.3264C3.83109 17.1733 3.48629 16.9247 3.2178 16.6037C2.91376 16.2401 2.74984 15.7484 2.422 14.7648L2.2488 14.2452C2.03481 13.6033 1.92782 13.2823 1.90732 12.9578C1.88915 12.6703 1.92082 12.3818 2.00093 12.105C2.09133 11.7927 2.26541 11.5026 2.61356 10.9224L4.16702 8.33325M15.8337 8.33325L16.1814 7.11621C16.3463 6.53922 16.4287 6.25073 16.3639 6.02248C16.3072 5.82254 16.1778 5.65102 16.0012 5.54155C15.7995 5.41659 15.4995 5.41659 14.8994 5.41659L5.10133 5.41659C4.50125 5.41659 4.20121 5.41659 3.99954 5.54155C3.82288 5.65102 3.69349 5.82254 3.63677 6.02248C3.57202 6.25073 3.65445 6.53922 3.8193 7.11621L4.16702 8.33325M10.0004 5.41659H7.05393C6.6198 5.41659 6.20344 5.24099 5.89646 4.92843C5.58948 4.61587 5.41702 4.19195 5.41702 3.74992C5.41702 3.30789 5.58948 2.88397 5.89646 2.57141C6.20344 2.25885 6.6198 2.08325 7.05393 2.08325C9.3456 2.08325 10.0004 5.41659 10.0004 5.41659ZM10.0004 5.41659H12.9468C13.3809 5.41659 13.7973 5.24099 14.1043 4.92843C14.4112 4.61587 14.5837 4.19195 14.5837 3.74992C14.5837 3.30789 14.4112 2.88397 14.1043 2.57141C13.7973 2.25885 13.3809 2.08325 12.9468 2.08325C10.6551 2.08325 10.0004 5.41659 10.0004 5.41659Z"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
export const FlasH = ({ color = "none", stroke = "#A273FF" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="flash">
        <path
          id="Icon"
          d="M12.9999 2L4.09332 12.6879C3.74451 13.1064 3.57011 13.3157 3.56744 13.4925C3.56512 13.6461 3.63359 13.7923 3.75312 13.8889C3.89061 14 4.16304 14 4.7079 14H11.9999L10.9999 22L19.9064 11.3121C20.2552 10.8936 20.4296 10.6843 20.4323 10.5075C20.4346 10.3539 20.3661 10.2077 20.2466 10.1111C20.1091 10 19.8367 10 19.2918 10H11.9999L12.9999 2Z"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
export const ArrowRightUp = ({ color = "none", stroke = "#A273FF" }) => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 12.3398L12 4.33984M12 4.33984H6.66667M12 4.33984V9.67318"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const Mail = ({ color = "none", stroke = "#9CA3AF" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill={color}
    >
      <path
        d="M1.66797 5.8335L8.47207 10.5964C9.02304 10.982 9.29853 11.1749 9.59819 11.2496C9.86288 11.3156 10.1397 11.3156 10.4044 11.2496C10.7041 11.1749 10.9796 10.982 11.5305 10.5964L18.3346 5.8335M5.66797 16.6668H14.3346C15.7348 16.6668 16.4348 16.6668 16.9696 16.3943C17.44 16.1547 17.8225 15.7722 18.0622 15.3018C18.3346 14.767 18.3346 14.067 18.3346 12.6668V7.3335C18.3346 5.93336 18.3346 5.2333 18.0622 4.69852C17.8225 4.22811 17.44 3.84566 16.9696 3.60598C16.4348 3.3335 15.7348 3.3335 14.3346 3.3335H5.66797C4.26784 3.3335 3.56777 3.3335 3.03299 3.60598C2.56259 3.84566 2.18014 4.22811 1.94045 4.69852C1.66797 5.2333 1.66797 5.93336 1.66797 7.3335V12.6668C1.66797 14.067 1.66797 14.767 1.94045 15.3018C2.18014 15.7722 2.56259 16.1547 3.03299 16.3943C3.56777 16.6668 4.26784 16.6668 5.66797 16.6668Z"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const Warning = ({ color = "#F59F0B" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clip-path="url(#clip0_1514_6095)">
        <path
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_1514_6095">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Tel = ({ color = "none", stroke = "#9CA3AF" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill={color}
    >
      <path
        d="M6.98356 7.37779C7.56356 8.58581 8.35422 9.71801 9.35553 10.7193C10.3568 11.7206 11.4891 12.5113 12.6971 13.0913C12.801 13.1412 12.8529 13.1661 12.9187 13.1853C13.1523 13.2534 13.4392 13.2045 13.637 13.0628C13.6927 13.0229 13.7403 12.9753 13.8356 12.88C14.1269 12.5887 14.2726 12.443 14.4191 12.3478C14.9715 11.9886 15.6837 11.9886 16.2361 12.3478C16.3825 12.443 16.5282 12.5887 16.8196 12.88L16.9819 13.0424C17.4248 13.4853 17.6462 13.7067 17.7665 13.9446C18.0058 14.4175 18.0058 14.9761 17.7665 15.449C17.6462 15.6869 17.4248 15.9083 16.9819 16.3512L16.8506 16.4825C16.4092 16.9239 16.1886 17.1446 15.8885 17.3131C15.5556 17.5001 15.0385 17.6346 14.6567 17.6334C14.3126 17.6324 14.0774 17.5657 13.607 17.4322C11.0792 16.7147 8.69387 15.361 6.70388 13.371C4.7139 11.381 3.36017 8.99569 2.6427 6.46786C2.50919 5.99749 2.44244 5.7623 2.44141 5.41818C2.44028 5.03633 2.57475 4.51925 2.76176 4.18633C2.9303 3.88631 3.15098 3.66563 3.59233 3.22428L3.72369 3.09292C4.16656 2.65005 4.388 2.42861 4.62581 2.30833C5.09878 2.0691 5.65734 2.0691 6.1303 2.30832C6.36812 2.42861 6.58955 2.65005 7.03242 3.09291L7.19481 3.25531C7.48615 3.54665 7.63182 3.69231 7.72706 3.8388C8.08622 4.3912 8.08622 5.10336 7.72706 5.65576C7.63182 5.80225 7.48615 5.94791 7.19481 6.23925C7.09955 6.33451 7.05192 6.38214 7.01206 6.43782C6.87038 6.63568 6.82146 6.92256 6.88957 7.15619C6.90873 7.22193 6.93367 7.27389 6.98356 7.37779Z"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const User = ({ color = "none", stroke = "#9CA3AF" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill={color}
    >
      <path
        d="M2.5 16.6667C4.44649 14.6021 7.08918 13.3333 10 13.3333C12.9108 13.3333 15.5535 14.6021 17.5 16.6667M13.75 6.25C13.75 8.32107 12.0711 10 10 10C7.92893 10 6.25 8.32107 6.25 6.25C6.25 4.17893 7.92893 2.5 10 2.5C12.0711 2.5 13.75 4.17893 13.75 6.25Z"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Calendar = ({ color = "none", stroke = "#9CA3AF" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill={color}
    >
      <path
        d="M17.5 8.33317H2.5M13.3333 1.6665V4.99984M6.66667 1.6665V4.99984M8.75 11.6665L10 10.8332V14.9998M8.95833 14.9998H11.0417M6.5 18.3332H13.5C14.9001 18.3332 15.6002 18.3332 16.135 18.0607C16.6054 17.821 16.9878 17.4386 17.2275 16.9681C17.5 16.4334 17.5 15.7333 17.5 14.3332V7.33317C17.5 5.93304 17.5 5.23297 17.2275 4.69819C16.9878 4.22779 16.6054 3.84534 16.135 3.60565C15.6002 3.33317 14.9001 3.33317 13.5 3.33317H6.5C5.09987 3.33317 4.3998 3.33317 3.86502 3.60565C3.39462 3.84534 3.01217 4.22779 2.77248 4.69819C2.5 5.23297 2.5 5.93304 2.5 7.33317V14.3332C2.5 15.7333 2.5 16.4334 2.77248 16.9681C3.01217 17.4386 3.39462 17.821 3.86502 18.0607C4.3998 18.3332 5.09987 18.3332 6.5 18.3332Z"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const Pass = ({ color = "none", stroke = "#9CA3AF" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill={color}
    >
      <path
        d="M14.1654 8.33333V6.66667C14.1654 4.36548 12.2999 2.5 9.9987 2.5C7.69751 2.5 5.83203 4.36548 5.83203 6.66667V8.33333M9.9987 12.0833V13.75M7.33203 17.5H12.6654C14.0655 17.5 14.7656 17.5 15.3003 17.2275C15.7707 16.9878 16.1532 16.6054 16.3929 16.135C16.6654 15.6002 16.6654 14.9001 16.6654 13.5V12.3333C16.6654 10.9332 16.6654 10.2331 16.3929 9.69836C16.1532 9.22795 15.7707 8.8455 15.3003 8.60582C14.7656 8.33333 14.0655 8.33333 12.6654 8.33333H7.33203C5.9319 8.33333 5.23183 8.33333 4.69705 8.60582C4.22665 8.8455 3.8442 9.22795 3.60451 9.69836C3.33203 10.2331 3.33203 10.9332 3.33203 12.3333V13.5C3.33203 14.9001 3.33203 15.6002 3.60451 16.135C3.8442 16.6054 4.22665 16.9878 4.69705 17.2275C5.23183 17.5 5.9319 17.5 7.33203 17.5Z"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const EyeSlashed = ({ color = "none", stroke = "#9CA3AF" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill={color}
    >
      <path
        d="M8.95245 4.2436C9.29113 4.19353 9.64051 4.16667 10.0003 4.16667C14.2545 4.16667 17.0461 7.9207 17.9839 9.40569C18.0974 9.58542 18.1542 9.67528 18.1859 9.81389C18.2098 9.91799 18.2098 10.0822 18.1859 10.1863C18.1541 10.3249 18.097 10.4154 17.9827 10.5963C17.7328 10.9918 17.3518 11.5476 16.8471 12.1504M5.6036 5.59586C3.80187 6.81808 2.57871 8.51615 2.01759 9.4044C1.90357 9.58489 1.84656 9.67514 1.81478 9.81373C1.79091 9.91783 1.7909 10.082 1.81476 10.1861C1.84652 10.3247 1.90328 10.4146 2.01678 10.5943C2.95462 12.0793 5.74618 15.8333 10.0003 15.8333C11.7157 15.8333 13.1932 15.223 14.4073 14.3972M2.50035 2.5L17.5003 17.5M8.23258 8.23223C7.78017 8.68464 7.50035 9.30964 7.50035 10C7.50035 11.3807 8.61963 12.5 10.0003 12.5C10.6907 12.5 11.3157 12.2202 11.7681 11.7678"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ChevronLeft = ({ color = "#ECE3FF", stroke = "#6B7280" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="12" fill={color} />
      <path
        d="M15 18L9 12L15 6"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ChevronDownSimple = ({
  classname = "",
  color = "none",
  stroke = "#A273FF",
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
    >
      <g id="chevron-down">
        <path
          id="Icon"
          d="M6 9L12 15L18 9"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
export const ChevronRightSimple = ({
  classname = "",
  color = "none",
  stroke = "#EF4444",
  strokeWidth = "2",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill={color}
    >
      <path
        d="M6 12.9429L10 8.94287L6 4.94287"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const WhatsappIcon = ({ stroke = "var(--shade-white)" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12.0377 3.29053C7.09761 3.29053 3.07723 7.16285 3.07548 11.9218C3.07432 13.4437 3.48774 14.929 4.27161 16.2372L3 20.7099L7.75142 19.5097C9.07309 20.2011 10.5427 20.5617 12.0343 20.5607H12.0377C16.9779 20.5607 20.9983 16.6878 21 11.9288C21.0012 9.62362 20.0698 7.45375 18.3772 5.82272C16.6852 4.19111 14.4352 3.29111 12.0377 3.29053ZM12.0377 19.1027H12.0348C10.6982 19.1027 9.3871 18.7566 8.24323 18.1028L7.97032 17.9472L5.15187 18.659L5.90439 16.0113L5.72729 15.7401C4.98343 14.6056 4.58745 13.2784 4.58806 11.9218C4.58981 7.96588 7.932 4.74853 12.0406 4.74853C14.0299 4.74911 15.9002 5.4964 17.3071 6.85221C18.714 8.20801 19.488 10.0109 19.4868 11.9282C19.4851 15.8841 16.1435 19.1027 12.0372 19.1027H12.0377ZM16.1237 13.7288C15.8996 13.6214 14.7987 13.0994 14.5932 13.0268C14.3882 12.9554 14.239 12.9182 14.0897 13.1342C13.9411 13.3502 13.5114 13.8362 13.3814 13.9796C13.2501 14.1236 13.1195 14.141 12.8954 14.0336C12.6712 13.9256 11.9495 13.698 11.0948 12.9629C10.4288 12.3916 9.97935 11.6855 9.84871 11.4689C9.71806 11.2535 9.83477 11.1368 9.94684 11.0294C10.0473 10.9336 10.171 10.7779 10.2825 10.6519C10.3939 10.5259 10.4311 10.4359 10.5066 10.2919C10.5809 10.1485 10.5437 10.0219 10.4874 9.91453C10.4311 9.80595 9.984 8.74453 9.79645 8.31311C9.61529 7.89272 9.43064 7.94904 9.29303 7.94208C9.16239 7.93627 9.01374 7.93453 8.86335 7.93453C8.71529 7.93453 8.472 7.98853 8.26645 8.20453C8.06148 8.42053 7.48258 8.94195 7.48258 10.0034C7.48258 11.0654 8.28503 12.0908 8.3971 12.2348C8.50916 12.3782 9.97645 14.5574 12.223 15.4922C12.7572 15.7134 13.1741 15.8464 13.4998 15.9463C14.0363 16.1106 14.5246 16.0868 14.9102 16.0316C15.3399 15.9695 16.2352 15.5102 16.421 15.0068C16.608 14.5034 16.608 14.0714 16.5523 13.9814C16.4977 13.8914 16.3479 13.8374 16.1237 13.7288Z"
        fill={stroke}
      />
    </svg>
  );
};
export const LessBtn = ({ color = "none", stroke = "#9CA3AF" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill={color}
    >
      <path
        d="M4.16797 10.4399H15.8346"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const MoreBtn = ({ color = "none", stroke = "#1E1A21" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill={color}
    >
      <path
        d="M10.0013 4.60645V16.2731M4.16797 10.4398H15.8346"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const HomeTypeIcon = ({ color = "none", stroke = "#1E1A21" }) => {
  return (
    <svg
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="home-03">
        <path
          id="Icon"
          d="M12.0013 28.4399V18.5733C12.0013 17.8265 12.0013 17.4532 12.1466 17.168C12.2745 16.9171 12.4784 16.7131 12.7293 16.5853C13.0145 16.4399 13.3879 16.4399 14.1346 16.4399H17.868C18.6147 16.4399 18.9881 16.4399 19.2733 16.5853C19.5242 16.7131 19.7282 16.9171 19.856 17.168C20.0013 17.4532 20.0013 17.8265 20.0013 18.5733V28.4399M2.66797 13.1066L14.7213 4.06661C15.1803 3.72235 15.4098 3.55022 15.6619 3.48387C15.8844 3.4253 16.1182 3.4253 16.3407 3.48387C16.5928 3.55022 16.8223 3.72235 17.2813 4.06661L29.3346 13.1066M5.33464 11.1066V24.1733C5.33464 25.6667 5.33464 26.4135 5.62529 26.9839C5.88095 27.4857 6.2889 27.8936 6.79067 28.1493C7.3611 28.4399 8.10783 28.4399 9.60131 28.4399H22.4013C23.8948 28.4399 24.6415 28.4399 25.212 28.1493C25.7137 27.8936 26.1217 27.4857 26.3773 26.9839C26.668 26.4135 26.668 25.6667 26.668 24.1733V11.1066L18.5613 5.02661C17.6433 4.33809 17.1843 3.99383 16.6802 3.86113C16.2352 3.74399 15.7674 3.74399 15.3225 3.86113C14.8183 3.99383 14.3593 4.33809 13.4413 5.02661L5.33464 11.1066Z"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
export const BuildingTypeIcon = ({ color = "none", stroke = "#1E1A21" }) => {
  return (
    <svg
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="building">
        <path
          id="building_2"
          d="M28.5701 7.01153H20.1892V3.86868C20.1881 3.31344 19.9671 2.7802 19.5742 2.38734C19.1824 1.99553 18.6492 1.77449 18.0939 1.77344H3.42727C2.87203 1.77449 2.33879 1.99449 1.94594 2.38734C1.55308 2.7802 1.33308 3.31344 1.33203 3.86868V29.0115C1.33308 29.5668 1.55413 30.1 1.94594 30.4918C2.33879 30.8847 2.87203 31.1057 3.42727 31.1068H28.5701C29.1254 31.1057 29.6576 30.8847 30.0504 30.4918C30.4433 30.099 30.6643 29.5668 30.6654 29.0115V9.10677C30.6643 8.55153 30.4433 8.01829 30.0504 7.62544C29.6586 7.23363 29.1254 7.01258 28.5701 7.01153ZM12.8558 29.0115H8.66536V23.7734H12.8558V29.0115ZM18.0939 29.0115H14.9511V23.7734C14.95 23.2182 14.729 22.685 14.3361 22.2931C13.9443 21.9003 13.4111 21.6792 12.8558 21.6782H8.66536C8.11013 21.6792 7.57689 21.9003 7.18403 22.2931C6.79222 22.685 6.57117 23.2182 6.57013 23.7734V29.0115H3.42727L3.42622 3.86868H18.0939V29.0115ZM28.5701 29.0115H20.1892V9.10677H28.5701V29.0115ZM25.4273 16.4401C25.4273 16.6475 25.3655 16.8497 25.2502 17.0226C25.136 17.1944 24.9716 17.3285 24.7809 17.4081C24.5892 17.4877 24.3786 17.5076 24.1754 17.4678C23.9721 17.427 23.7856 17.3274 23.639 17.1808C23.4923 17.0341 23.3928 16.8476 23.3519 16.6444C23.3121 16.4412 23.332 16.2306 23.4116 16.0389C23.4913 15.8482 23.6254 15.6837 23.7972 15.5695C23.97 15.4543 24.1722 15.3925 24.3796 15.3925C24.6573 15.3925 24.9244 15.5025 25.1203 15.6994C25.3173 15.8953 25.4273 16.1625 25.4273 16.4401ZM23.332 12.2496C23.332 12.0422 23.3938 11.84 23.5091 11.6672C23.6233 11.4953 23.7877 11.3612 23.9784 11.2816C24.1701 11.202 24.3807 11.1821 24.5839 11.2219C24.7872 11.2628 24.9736 11.3623 25.1203 11.509C25.267 11.6556 25.3665 11.8421 25.4074 12.0453C25.4472 12.2486 25.4273 12.4592 25.3476 12.6509C25.268 12.8415 25.1339 13.006 24.9621 13.1202C24.7893 13.2354 24.5871 13.2972 24.3796 13.2972C24.102 13.2972 23.8349 13.1872 23.639 12.9903C23.442 12.7944 23.332 12.5272 23.332 12.2496ZM14.9511 16.4401C14.9511 16.6475 14.8893 16.8497 14.774 17.0226C14.6598 17.1944 14.4954 17.3285 14.3047 17.4081C14.113 17.4877 13.9024 17.5076 13.6992 17.4678C13.4959 17.427 13.3095 17.3274 13.1628 17.1808C13.0161 17.0341 12.9166 16.8476 12.8757 16.6444C12.8359 16.4412 12.8558 16.2306 12.9355 16.0389C13.0151 15.8482 13.1492 15.6837 13.321 15.5695C13.4938 15.4543 13.696 15.3925 13.9035 15.3925C14.1811 15.3925 14.4482 15.5025 14.6441 15.6994C14.8411 15.8953 14.9511 16.1625 14.9511 16.4401ZM14.9511 12.2496C14.9511 12.4571 14.8893 12.6592 14.774 12.8321C14.6598 13.0039 14.4954 13.138 14.3047 13.2176C14.113 13.2972 13.9024 13.3172 13.6992 13.2773C13.4959 13.2365 13.3095 13.137 13.1628 12.9903C13.0161 12.8436 12.9166 12.6572 12.8757 12.4539C12.8359 12.2507 12.8558 12.0401 12.9355 11.8484C13.0151 11.6577 13.1492 11.4932 13.321 11.3791C13.4938 11.2638 13.696 11.202 13.9035 11.202C14.1811 11.202 14.4482 11.312 14.6441 11.509C14.8411 11.7049 14.9511 11.972 14.9511 12.2496ZM14.9511 8.05915C14.9511 8.26658 14.8893 8.46877 14.774 8.64163C14.6598 8.81344 14.4954 8.94753 14.3047 9.02715C14.113 9.10677 13.9024 9.12668 13.6992 9.08687C13.4959 9.04601 13.3095 8.94649 13.1628 8.79982C13.0161 8.65315 12.9166 8.46668 12.8757 8.26344C12.8359 8.0602 12.8558 7.84963 12.9355 7.65791C13.0151 7.46725 13.1492 7.30277 13.321 7.18858C13.4938 7.07334 13.696 7.01153 13.9035 7.01153C14.1811 7.01153 14.4482 7.12153 14.6441 7.31848C14.8411 7.51439 14.9511 7.78153 14.9511 8.05915ZM8.66536 16.4401C8.66536 16.6475 8.60355 16.8497 8.48832 17.0226C8.37413 17.1944 8.20965 17.3285 8.01898 17.4081C7.82727 17.4877 7.6167 17.5076 7.41346 17.4678C7.21022 17.427 7.02374 17.3274 6.87708 17.1808C6.73041 17.0341 6.63089 16.8476 6.59003 16.6444C6.55022 16.4412 6.57013 16.2306 6.64975 16.0389C6.72936 15.8482 6.86346 15.6837 7.03527 15.5695C7.20813 15.4543 7.41032 15.3925 7.61775 15.3925C7.89536 15.3925 8.16251 15.5025 8.35841 15.6994C8.55536 15.8953 8.66536 16.1625 8.66536 16.4401ZM8.66536 12.2496C8.66536 12.4571 8.60355 12.6592 8.48832 12.8321C8.37413 13.0039 8.20965 13.138 8.01898 13.2176C7.82727 13.2972 7.6167 13.3172 7.41346 13.2773C7.21022 13.2365 7.02374 13.137 6.87708 12.9903C6.73041 12.8436 6.63089 12.6572 6.59003 12.4539C6.55022 12.2507 6.57013 12.0401 6.64975 11.8484C6.72936 11.6577 6.86346 11.4932 7.03527 11.3791C7.20813 11.2638 7.41032 11.202 7.61775 11.202C7.89536 11.202 8.16251 11.312 8.35841 11.509C8.55536 11.7049 8.66536 11.972 8.66536 12.2496ZM8.66536 8.05915C8.66536 8.26658 8.60355 8.46877 8.48832 8.64163C8.37413 8.81344 8.20965 8.94753 8.01898 9.02715C7.82727 9.10677 7.6167 9.12668 7.41346 9.08687C7.21022 9.04601 7.02374 8.94649 6.87708 8.79982C6.73041 8.65315 6.63089 8.46668 6.59003 8.26344C6.55022 8.0602 6.57013 7.84963 6.64975 7.65791C6.72936 7.46725 6.86346 7.30277 7.03527 7.18858C7.20813 7.07334 7.41032 7.01153 7.61775 7.01153C7.89536 7.01153 8.16251 7.12153 8.35841 7.31848C8.55536 7.51439 8.66536 7.78153 8.66536 8.05915Z"
          fill={stroke}
        />
      </g>
    </svg>
  );
};
export const PhotoIcon = ({ color = "none", stroke = "#fff" }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="image-03">
        <path
          id="Icon"
          d="M3.20407 15.5459L8.15147 10.5985C8.44849 10.3015 8.59699 10.153 8.76824 10.0974C8.91887 10.0484 9.08113 10.0484 9.23176 10.0974C9.40301 10.153 9.55152 10.3015 9.84853 10.5985L14.7629 15.5129M10.5 11.25L12.6515 9.09853C12.9485 8.80152 13.097 8.65301 13.2682 8.59737C13.4189 8.54842 13.5811 8.54842 13.7318 8.59737C13.903 8.65301 14.0515 8.80152 14.3485 9.09853L16.5 11.25M7.5 6.75C7.5 7.57843 6.82843 8.25 6 8.25C5.17157 8.25 4.5 7.57843 4.5 6.75C4.5 5.92157 5.17157 5.25 6 5.25C6.82843 5.25 7.5 5.92157 7.5 6.75ZM5.1 15.75H12.9C14.1601 15.75 14.7902 15.75 15.2715 15.5048C15.6948 15.289 16.039 14.9448 16.2548 14.5215C16.5 14.0402 16.5 13.4101 16.5 12.15V5.85C16.5 4.58988 16.5 3.95982 16.2548 3.47852C16.039 3.05516 15.6948 2.71095 15.2715 2.49524C14.7902 2.25 14.1601 2.25 12.9 2.25H5.1C3.83988 2.25 3.20982 2.25 2.72852 2.49524C2.30516 2.71095 1.96095 3.05516 1.74524 3.47852C1.5 3.95982 1.5 4.58988 1.5 5.85V12.15C1.5 13.4101 1.5 14.0402 1.74524 14.5215C1.96095 14.9448 2.30516 15.289 2.72852 15.5048C3.20982 15.75 3.83988 15.75 5.1 15.75Z"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
export const ShareIcon = ({ color = "transparent", stroke = "#1E1A21" }) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="share-06">
        <path
          id="Icon"
          d="M14.3609 8.40513C14.5237 8.26563 14.605 8.19589 14.6348 8.11289C14.661 8.04004 14.661 7.96035 14.6348 7.8875C14.605 7.8045 14.5237 7.73476 14.3609 7.59526L8.71375 2.75484C8.4336 2.51471 8.29353 2.39465 8.17493 2.3917C8.07186 2.38915 7.97341 2.43443 7.90828 2.51435C7.83333 2.6063 7.83333 2.7908 7.83333 3.15978V6.02328C6.41021 6.27225 5.10773 6.99337 4.13981 8.07611C3.08455 9.25654 2.50082 10.7842 2.5 12.3675V12.7755C3.19956 11.9328 4.073 11.2512 5.06051 10.7775C5.93113 10.3598 6.87228 10.1124 7.83333 10.0472V12.8406C7.83333 13.2096 7.83333 13.3941 7.90828 13.486C7.97341 13.566 8.07186 13.6112 8.17493 13.6087C8.29353 13.6057 8.4336 13.4857 8.71375 13.2455L14.3609 8.40513Z"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
export const ChaletTypeIcon = ({ color = "none", stroke = "#1E1A21" }) => {
  return (
    <svg
      width="30"
      height="25"
      viewBox="0 0 30 25"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Calque 1">
        <g id="Group">
          <path
            id="Vector"
            d="M0.332031 9.16297C0.332031 9.16297 0.722979 8.88198 0.918453 8.72316C4.13156 6.01095 7.33245 3.31097 10.5456 0.598764C10.6066 0.549896 10.6677 0.501027 10.7532 0.439941C12.6225 2.01595 14.4917 3.59196 16.4098 5.20462V3.29875C16.4098 2.81969 16.7981 2.43133 17.2772 2.43133C17.7563 2.43133 18.1446 2.81958 18.1446 3.29864C18.1446 4.30757 18.1446 5.41845 18.1446 6.34082C18.1446 6.57294 18.2057 6.71955 18.389 6.87837C19.1831 7.52588 19.9527 8.19782 20.7346 8.84533C20.8324 8.93085 20.979 9.00415 21.1134 9.00415C23.9233 9.00415 26.7455 9.00415 29.5554 9.00415C29.5921 9.00415 29.6287 9.00415 29.6654 8.99193V10.7145H27.9916V23.6421C27.9916 24.1944 27.5439 24.6421 26.9916 24.6421H3.00578C2.45349 24.6421 2.00578 24.1944 2.00578 23.6421V10.067C1.78587 10.2381 1.61483 10.3847 1.44379 10.5191C1.06506 10.0793 0.698545 9.65166 0.332031 9.22406C0.332031 9.19962 0.332031 9.16297 0.332031 9.16297ZM26.2568 22.9072V10.7145C26.1224 10.7145 26.0124 10.7145 25.9025 10.7145C24.1188 10.7145 22.3351 10.7145 20.5514 10.7145C20.4048 10.7145 20.2215 10.6657 20.1116 10.5679C17.3871 8.28334 14.6749 5.99874 11.9627 3.70192C11.5596 3.35984 11.1442 3.01776 10.7532 2.67568C10.7044 2.71233 10.6799 2.72454 10.6555 2.74898C8.39534 4.65485 6.14739 6.54851 3.89943 8.45438C3.8017 8.5399 3.74061 8.71094 3.74061 8.84533C3.74061 13.4268 3.74061 18.0082 3.74061 22.5896C3.74061 22.6873 3.74061 22.7973 3.75283 22.895H7.68674V17.6765C7.68674 17.1242 8.13446 16.6765 8.68674 16.6765H12.832C13.3842 16.6765 13.832 17.1242 13.832 17.6765V22.9072H26.2568ZM12.0727 22.9072V18.8991C12.0727 18.623 11.8488 18.3991 11.5727 18.3991H9.90936C9.63322 18.3991 9.40936 18.623 9.40936 18.8991V22.9072H12.0727Z"
            fill={stroke}
          />
          <path
            id="Vector_2"
            d="M7.61328 8.26904C7.61328 7.71676 8.061 7.26904 8.61328 7.26904H12.8685C13.4207 7.26904 13.8685 7.71676 13.8685 8.26904V12.3776C13.8685 12.9299 13.4207 13.3776 12.8685 13.3776H8.61328C8.061 13.3776 7.61328 12.9299 7.61328 12.3776V8.26904ZM12.1581 9.49166C12.1581 9.21552 11.9342 8.99166 11.6581 8.99166H9.8359C9.55975 8.99166 9.3359 9.21552 9.3359 9.49166V11.1428C9.3359 11.4189 9.55975 11.6428 9.8359 11.6428H11.6581C11.9342 11.6428 12.1581 11.4189 12.1581 11.1428V9.49166Z"
            fill={stroke}
          />
          <path
            id="Vector_3"
            d="M18.2773 14.6465C18.2773 14.0942 18.7251 13.6465 19.2773 13.6465H23.5203C24.0726 13.6465 24.5203 14.0942 24.5203 14.6465V18.7551C24.5203 19.3073 24.0726 19.7551 23.5203 19.7551H19.2773C18.7251 19.7551 18.2773 19.3073 18.2773 18.7551V14.6465ZM20.4877 15.3691C20.2116 15.3691 19.9877 15.593 19.9877 15.8691V17.5324C19.9877 17.8086 20.2116 18.0324 20.4877 18.0324H22.3099C22.586 18.0324 22.8099 17.8086 22.8099 17.5324V15.8691C22.8099 15.593 22.586 15.3691 22.3099 15.3691H20.4877Z"
            fill={stroke}
          />
        </g>
      </g>
    </svg>
  );
};

export const MobileResiIcon = ({ color = "none", stroke = "#9CA3AF" }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="building-07">
        <path
          id="Icon"
          d="M6.2513 9.16667H3.83464C3.36792 9.16667 3.13457 9.16667 2.95631 9.25749C2.79951 9.33739 2.67202 9.46487 2.59213 9.62167C2.5013 9.79993 2.5013 10.0333 2.5013 10.5V17.5M13.7513 9.16667H16.168C16.6347 9.16667 16.868 9.16667 17.0463 9.25749C17.2031 9.33739 17.3306 9.46487 17.4105 9.62167C17.5013 9.79993 17.5013 10.0333 17.5013 10.5V17.5M13.7513 17.5V5.16667C13.7513 4.23325 13.7513 3.76654 13.5696 3.41002C13.4099 3.09641 13.1549 2.84144 12.8413 2.68166C12.4848 2.5 12.0181 2.5 11.0846 2.5H8.91797C7.98455 2.5 7.51784 2.5 7.16132 2.68166C6.84771 2.84144 6.59275 3.09641 6.43296 3.41002C6.2513 3.76654 6.2513 4.23325 6.2513 5.16667V17.5M18.3346 17.5H1.66797M9.16797 5.83333H10.8346M9.16797 9.16667H10.8346M9.16797 12.5H10.8346"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const MobileCalendarIcon = ({ color = "none", stroke = "#9CA3AF" }) => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="calendar-date">
        <path
          id="Icon"
          d="M17.9023 8.33335H2.90234M13.7357 1.66669V5.00002M7.06901 1.66669V5.00002M9.15234 11.6667L10.4023 10.8334V15M9.36068 15H11.444M6.90234 18.3334H13.9023C15.3025 18.3334 16.0025 18.3334 16.5373 18.0609C17.0077 17.8212 17.3902 17.4387 17.6299 16.9683C17.9023 16.4336 17.9023 15.7335 17.9023 14.3334V7.33335C17.9023 5.93322 17.9023 5.23316 17.6299 4.69838C17.3902 4.22797 17.0077 3.84552 16.5373 3.60584C16.0025 3.33335 15.3025 3.33335 13.9023 3.33335H6.90234C5.50221 3.33335 4.80215 3.33335 4.26737 3.60584C3.79696 3.84552 3.41451 4.22797 3.17483 4.69838C2.90234 5.23316 2.90234 5.93322 2.90234 7.33335V14.3334C2.90234 15.7335 2.90234 16.4336 3.17483 16.9683C3.41451 17.4387 3.79696 17.8212 4.26737 18.0609C4.80215 18.3334 5.50221 18.3334 6.90234 18.3334Z"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const MobileReservationIcon = ({
  color = "none",
  stroke = "#9CA3AF",
}) => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="menu-04">
        <path
          id="Icon"
          d="M2.69922 10H17.6992M2.69922 5H17.6992M7.69922 15H17.6992"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
export const MobileStatsIcon = ({ color = "none", stroke = "#9CA3AF" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill={color}
    >
      <path
        d="M21 21H6.2C5.07989 21 4.51984 21 4.09202 20.782C3.71569 20.5903 3.40973 20.2843 3.21799 19.908C3 19.4802 3 18.9201 3 17.8V3M7 14.5V17.5M11.5 11.5V17.5M16 8.5V17.5M20.5 5.5V17.5"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const HoteChambersIcon = ({ color = "none", stroke = "#A273FF" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill={color}
    >
      <path
        d="M1.33594 14.6663H14.6693M11.0795 1.80829V14.3244M2.87287 14.1906V1.78829C2.87287 1.53684 3.09235 1.33301 3.36363 1.33301M3.36363 1.33301H10.5929C10.8636 1.33301 11.0831 1.53684 11.0831 1.78829V14.1906M3.36363 1.33301H12.618C12.8888 1.33301 13.1088 1.53684 13.1088 1.78829V14.1906"
        stroke={stroke}
        strokeWidth="2"
        stroke-miterlimit="10"
      />
      <path
        d="M9.69591 8.0628C9.69591 8.32819 9.48053 8.54357 9.21514 8.54357C8.94976 8.54357 8.73438 8.32819 8.73438 8.0628C8.73438 7.79742 8.94976 7.58203 9.21514 7.58203C9.48053 7.58203 9.69591 7.79742 9.69591 8.0628Z"
        fill={stroke}
      />
      <path
        d="M9.69591 8.0628C9.69591 8.32819 9.48053 8.54357 9.21514 8.54357C8.94976 8.54357 8.73438 8.32819 8.73438 8.0628C8.73438 7.79742 8.94976 7.58203 9.21514 7.58203C9.48053 7.58203 9.69591 7.79742 9.69591 8.0628Z"
        fill={stroke}
      />
    </svg>
  );
};
export const HotePersonsIcon = ({ color = "none", stroke = "#A273FF" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M10.6693 2.31184C11.6571 2.80274 12.3359 3.82209 12.3359 5C12.3359 6.17791 11.6571 7.19726 10.6693 7.68816M12.0026 11.1776C13.0102 11.6336 13.9176 12.3767 14.6693 13.3333M1.33594 13.3333C2.6336 11.6817 4.39539 10.6667 6.33594 10.6667C8.27648 10.6667 10.0383 11.6817 11.3359 13.3333M9.33594 5C9.33594 6.65685 7.99279 8 6.33594 8C4.67908 8 3.33594 6.65685 3.33594 5C3.33594 3.34315 4.67908 2 6.33594 2C7.99279 2 9.33594 3.34315 9.33594 5Z"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const CashIcon = ({ color = "none", stroke = "var(--primary-500)" }) => {
  return (
    <svg
      width="27"
      height="24"
      viewBox="0 0 27 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="cash">
        <path
          id="Vector"
          d="M4.21412 17.5721H22.7856M5.76174 20.715H21.2379M24.3332 6.5721C23.307 6.5721 22.3229 6.19583 21.5973 5.52605C20.8718 4.85628 20.4641 3.94787 20.4641 3.00067M2.6665 6.5721C3.17459 6.5721 3.67771 6.47972 4.14712 6.30024C4.61654 6.12076 5.04306 5.85769 5.40233 5.52605C5.76161 5.19441 6.0466 4.8007 6.24104 4.3674C6.43548 3.93409 6.53555 3.46968 6.53555 3.00067M24.3332 10.8578C23.307 10.8578 22.3229 11.2341 21.5973 11.9039C20.8718 12.5736 20.4641 13.482 20.4641 14.4292M2.6665 10.8578C3.17459 10.8578 3.67771 10.9502 4.14712 11.1297C4.61654 11.3092 5.04306 11.5722 5.40233 11.9039C5.76161 12.2355 6.0466 12.6292 6.24104 13.0625C6.43548 13.4958 6.53555 13.9602 6.53555 14.4292M23.5594 14.4292H3.44031C3.01295 14.4292 2.6665 14.1094 2.6665 13.715V3.71496C2.6665 3.32047 3.01295 3.00067 3.44031 3.00067H23.5594C23.9867 3.00067 24.3332 3.32047 24.3332 3.71496V13.715C24.3332 14.1094 23.9867 14.4292 23.5594 14.4292ZM17.3689 8.71496C17.3689 10.6874 15.6367 12.2864 13.4998 12.2864C11.363 12.2864 9.63079 10.6874 9.63079 8.71496C9.63079 6.74251 11.363 5.14353 13.4998 5.14353C15.6367 5.14353 17.3689 6.74251 17.3689 8.71496Z"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
